import { useEffect } from 'react'
import { useNodeMapActions } from '../features/keyOperations/store/NodeMapStore'
import { ScrollableTreeRef } from '../types/types'

/**
 * Side effect to build contentItem.id to node map when tree data changes
 * The node map enables fast O(1) lookups from a contentItem.id to its corresponding DataNode in the tree.
 * This is useful for keyboard navigation, contextual actions, and efficiently finding parent/related nodes
 * without traversing the entire tree structure each time.
 * @param treeData - The tree data array to watch.
 * @param treeRef - The tree reference to store for navigation support.
 * @param setTreeRef - Function to set the tree reference in the store.
 */
export const useBuildNodeMapOnTreeDataChange = (
    treeData: any[], 
    treeRef?: React.MutableRefObject<ScrollableTreeRef>,
    setTreeRef?: (treeRef: React.MutableRefObject<ScrollableTreeRef>) => void
) => {
    // hook for managing contentItem.id to node mapping
    const { buildNodeMap } = useNodeMapActions()

    useEffect(() => {
        if (treeData?.length > 0) {
            buildNodeMap(treeData)
        }
    }, [treeData, buildNodeMap])

    // Store tree ref in workspace store for use by navigation
    useEffect(() => {
        if (treeRef && setTreeRef) {
            setTreeRef(treeRef)
        }
    }, [treeRef, setTreeRef])
}
